/**
 * Singapura — AR Active Declaration Statement chatflow (CSI002). title → 회사 선택 → confirm.
 *   steps/handleEvent 는 형제 aura agm 플로우 재사용. id·taskCode·환영문만 별도.
 */
import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/types';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import { auraAgmFlow } from '../../aura/agm/chatflows/auraAgmFlow';

export const singapuraActiveDeclarationFlow: ChatFlow = {
  ...auraAgmFlow,
  id: 'singapura-active-declaration',
  taskCodeMatch: ['CSI002'],
  categoryMatch: ['active declaration', 'declaration statement', 'annual return', 'ar'],

  getInitialMessages(_preSet: PreSetSelection): ConversationMessage[] {
    return [
      {
        role: 'ai',
        content:
          `Welcome to **Singapura — Active Declaration Statement** (Annual Return).\n\n` +
          `This preset prepares the officer's declaration for the AR — verification of particulars, share transfers, ` +
          `exempt private / small-company status, unaudited/audited FS, and solvency — to be signed by a director.\n\n` +
          `First, enter a **Task Title**, then select the **company**.`,
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },
};
